import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $UpdateAction = (tag, _1) => ({tag, _1});
const Delete = /* #__PURE__ */ $UpdateAction("Delete");
const Update = value0 => $UpdateAction("Update", value0);
const updateActionToMaybe = v => {
  if (v.tag === "Delete") { return Data$dMaybe.Nothing; }
  if (v.tag === "Update") { return Data$dMaybe.$Maybe("Just", v._1); }
  $runtime.fail();
};
const genericEntityId = {
  to: x => {
    if (x.tag === "Inl") { return Delete; }
    if (x.tag === "Inr") { return $UpdateAction("Update", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Delete") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Update") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showUpdateAction = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Delete"});
      const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [dictShow.show(v)]})({reflectSymbol: () => "Update"});
      return x => {
        if (x.tag === "Delete") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
        if (x.tag === "Update") { return $1["genericShow'"](x._1); }
        $runtime.fail();
      };
    })()
  }
);
const udecodeUpdateAction = dictDecodeSingleConstructorArgument => (
  {
    unsafeDecode: (() => {
      const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
        reflectSymbol: () => "Delete"
      }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "Update"})(dictDecodeSingleConstructorArgument)))(Unscramble$dGeneric.defaultOptions);
      return x => {
        const $1 = $0(x);
        if ($1.tag === "Inl") { return Delete; }
        if ($1.tag === "Inr") { return $UpdateAction("Update", $1._1); }
        $runtime.fail();
      };
    })()
  }
);
const eqUpdateAction = dictEq => (
  {
    eq: x => y => {
      if (x.tag === "Delete") {
        if (y.tag === "Delete") { return true; }
        if (y.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x.tag === "Update") {
        if (y.tag === "Delete") { return false; }
        if (y.tag === "Update") { return dictEq.eq(x._1)(y._1); }
        $runtime.fail();
      }
      if (y.tag === "Delete") { $runtime.fail(); }
      if (y.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }
);
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeUpdateAction = dictGenericEncodeArgs => (
  {
    encode: (() => {
      const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Delete"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
      const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Update"})(dictGenericEncodeArgs);
      return x => {
        if (x.tag === "Delete") {
          return $0.encodeOpts({
            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: true,
            unwrapSingleRecordArguments: true,
            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
          })(Data$dGeneric$dRep.NoArguments);
        }
        if (x.tag === "Update") {
          return $1.encodeOpts({
            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: true,
            unwrapSingleRecordArguments: true,
            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
          })(x._1);
        }
        $runtime.fail();
      };
    })()
  }
);
const decodeUpdateAction = dictGenericDecodeArgs => (
  {
    decode: Foreign$dGeneric.genericDecode(genericEntityId)(Foreign$dGeneric$dClass.genericDecodeSum(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "Delete"
    })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(Foreign$dGeneric$dClass.genericDecodeConstructor({
      reflectSymbol: () => "Update"
    })(dictGenericDecodeArgs)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(encodingOpts)
  }
);
export {
  $UpdateAction,
  Delete,
  Update,
  decodeUpdateAction,
  encodeUpdateAction,
  encodingOpts,
  eqUpdateAction,
  genericEntityId,
  showUpdateAction,
  udecodeUpdateAction,
  updateActionToMaybe
};
